// contractOptions.js

export const statusOptions = [
      { value: 'Draft', label: 'Entwurf' },
      { value: 'Active', label: 'Aktiv' },
      { value: 'Completed', label: 'Abgeschlossen' },
      { value: 'Cancelled', label: 'Abgebrochen' },
    ];